import { all, takeLatest } from 'lib/redux';
import { LOAD_CONTACT_INFO, CONTACT_INFO_SUBMIT } from 'constants/ActionTypes';
import { loadContactInformationPageSaga, submitContactInfoSaga } from './ContactInformation.saga';

export default function* watchers() {
  yield all([
    takeLatest(LOAD_CONTACT_INFO, loadContactInformationPageSaga),
    takeLatest(CONTACT_INFO_SUBMIT, submitContactInfoSaga),
  ]);
}
